import { render, staticRenderFns } from "./quote-image.vue?vue&type=template&id=8ba0af98&"
import script from "./quote-image.js?vue&type=script&lang=js&"
export * from "./quote-image.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports